import React, { Component } from "react";
import OperationFleetItem from "./FleetItem";
import Registry from "../../../Utils/Registry";
import {Button, Input, InputGroup, InputGroupAddon, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import TYSelect from "../../TYSelect";
import OperationsFleetBaseForm from "./BaseForm";

class OperationFleetList extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            fleet: [],
            loading: false,
            success: false,
            filter: "",
            advanced_search: false,
            fleet_categories: [],
            add_vehicle_shown: false
        };
    }

    componentDidMount(){
        this.getFleet();
    }

    getFleet = () => {
        this.setState({loading: true});

        this.api.get("/fleet?type=business")
            .then(({fleet}) => this.setState({
                loading: false,
                fleet
            }))
            .catch(() => this.setState({loading: false}));
    }

    setSearch = e => this.setState({filter: e.target.value});
    toggleAddVehicleModal = () => this.setState({add_vehicle_shown: !this.state.add_vehicle_shown});

    onNewVehicleAdded = () => {
        this.getFleet();
        this.toggleAddVehicleModal();
    };

    filterFleet = ({category, color, description, gas, plate}) => {
        const { filter } = this.state;
        const filterLower = filter.toLowerCase();

        return !filter 
            || (category || "").toLowerCase().includes(filterLower)
            || (color || "").toLowerCase().includes(filterLower)
            || (description || "").toLowerCase().includes(filterLower)
            || ((gas && gas.name) || "").toLowerCase().includes(filterLower)
            || (plate || "").toLowerCase().includes(filterLower);
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-between pad-b-10">
                    <h2 className="ty-subtitle">
                        Votre flotte {this.state.fleet.length ? " (" + this.state.fleet.length + ")" : ""}
                    </h2>

                    <div>
                        <Button color="primary" className="text-uppercase btn-xs" onClick={this.toggleAddVehicleModal}>
                            <i className="icon icon-plus marg-r-10"> </i> Ajouter
                        </Button>
                    </div>
                </div>

                <div className="ty-block">
                    <div className="ty-list-item border-b-1-gray relative pad-b-5">
                        <Input
                            placeholder="Modèle, plaque d'immatriculation, categories, .."
                            className="no-focus"
                            value={this.state.filter}
                            onChange={this.setSearch}
                        />
                    </div>
                    <div className="relative">
                        {
                            !this.state.loading
                                ?
                                    (
                                        this.state.fleet.length
                                            ?
                                            this.state.fleet.filter(this.filterFleet)
                                                .map((vehicle, i) => {
                                                    return <OperationFleetItem
                                                        key={i}
                                                        vehicle={vehicle}
                                                        vehicleDeleted={this.getFleet}
                                                        vehicleUpdated={this.getFleet}
                                                        gas_list={this.props.gas_list}
                                                    />;
                                                })
                                            :
                                            (
                                                this.state.filter != ""
                                                    ?
                                                    <div className="center">
                                                        Aucun véhicule ne correspond à votre recherche
                                                    </div>
                                                    :
                                                    <div className="center">
                                                        Votre flotte ne contient aucun véhicule
                                                    </div>
                                            )
                                    )
                                :
                                    this.state.loading ?
                                        <div className="center">
                                            <i className="icon icon-loading animated spin infinite f-24 blue_dark"> </i>
                                        </div>
                                        :
                                        ""
                        }
                    </div>
                </div>

                <Modal isOpen={this.state.add_vehicle_shown} toggle={this.toggleAddVehicleModal}>
                    <ModalHeader toggle={this.toggleAddVehicleModal}>Ajouter un v&eacute;hicule</ModalHeader>
                    <ModalBody>
                        <OperationsFleetBaseForm 
                            newVehicleAdded={this.onNewVehicleAdded} 
                            showTitle={false} 
                            gas_list={this.props.gas_list} 
                            tyBlock={false} 
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

OperationFleetList.defaultProps = {
    onVehicleUpdated: vehicle => {},
    gas_list: []
};

export default OperationFleetList;



// WEBPACK FOOTER //
// ./src/components/Operations/Fleet/FleetList.js